import { render, staticRenderFns } from "./vip.vue?vue&type=template&id=aeb7146e&scoped=true"
import script from "./vip.vue?vue&type=script&lang=js"
export * from "./vip.vue?vue&type=script&lang=js"
import style0 from "./vip.vue?vue&type=style&index=0&id=aeb7146e&prod&lang=css"
import style1 from "./vip.vue?vue&type=style&index=1&id=aeb7146e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb7146e",
  null
  
)

export default component.exports